module.exports = __webpack_public_path__ + "images/emoji/point_right.1f0de89e7cdd3f50434a.png";